import { useCallback, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate } from 'react-router';

import { canLoginToAdmin, useUserActions, useUserInfo, useUserToken } from '@/store/userStore';

import PageError from '@/pages/sys/error/PageError';
import { useRouter } from '../hooks';

type Props = {
  children: React.ReactNode;
};
export default function ProtectedRoute({ children }: Props) {
  const { accessToken } = useUserToken();
  const userInfo = useUserInfo();

  const hasAdminSession = Boolean(accessToken && canLoginToAdmin(userInfo));

  if (!hasAdminSession) {
    return <Navigate to="/login" replace />;
  }

  return <ErrorBoundary FallbackComponent={PageError}>{children}</ErrorBoundary>;
}
